export const LOYALTY_FAST_TRACK_EXPIRY_LOCAL_STORAGE_KEY = {
  MODAL_CLOSED_AT: 'loyaltyFastTrackExpiryModalClosedAt',
  BANNER_CLOSED_AT: 'loyaltyFastTrackExpiryBannerClosedAt'
}
